<template>
  <div class="cardDetail">
    <div class="cardLists">
      <van-swipe
        :loop="false"
        @change="changeCard"
        :initial-swipe="cardIndex"
        :width="280"
      >
        <van-swipe-item v-for="(item, idx) in cardLists" v-bind:key="idx">
          <div class="cardItem">
            <div class="card-logo">
              <img width="32" height="32" src="../../assets/image/sumguo.png" />
            </div>
            <div class="card-name">Stored value card</div>
            <div class="card-botton">
              <div class="text">{{ item.prepaidCardCode }}</div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-tabs v-model="cardIndex">
      <van-tab v-for="(item, idx) in cardLists" v-bind:key="idx"
        ><div class="card-info">
          <van-divider />
          <van-grid :column-num="2" :border="false" style="height: 55px">
            <van-grid-item style="border-right: 1px solid #ccc" text="余额">
              <div class="van-grid-item__text">余额</div>
              <div class="value">{{ item.surplusMoney }}</div>
            </van-grid-item>
            <van-grid-item text="适用门店">
              <div class="van-grid-item__text">适用门店</div>
              <div class="value" v-if="!item.isApplicableStore">不适用</div>
              <div class="value" v-else>适用</div>
            </van-grid-item>
          </van-grid>
          <van-divider />
        </div>
        <div class="card-active">
          <van-cell
            v-if="item.isApplicableStore"
            is-link
            @click="toCardRecharge(item.prepaidCardCode)"
            >充值</van-cell
          >
          <van-cell
            v-if="item.isApplicableStore"
            is-link
            @click="toShopcart(item.prepaidCardCode)"
            >下单</van-cell
          >
          <van-cell is-link @click="toCardRecord(item.prepaidCardCode)"
            >消费记录</van-cell
          >
          <div></div></div
      ></van-tab>
    </van-tabs>

    <!-- <van-popup v-model="showPopup" position="bottom" :style="{ height: '60%' }">
      <van-coupon-list
        :coupons="coupons"
        :chosen-coupon="chosenCoupon"
        :disabled-coupons="disabledCoupons"
        :show-count="false"
        :show-exchange-bar="false"
        enabled-title="充值记录"
        disabled-title="消费记录"
      />
    </van-popup> -->
  </div>
</template>

<script>
import "../../assets/css/cardDetail.less";
import { getCardInfo } from "@/api/card";
import { queryGet } from "@/api/common";
export default {
  name: "CardDetail",
  data() {
    return {
      showPopup: false,
      cardLists: [],
      cardNo: "",
      cardIndex: 0,
    };
  },
  components: {},
  created() {
    this.loadComments();
    this.loadCard();
  },
  methods: {
    loadComments() {
      // debugger
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";
    },
    loadCard() {
      let _this = this;
      _this.cardNo = _this.cardInfo.prepaidCardCode;
      let phone = _this.cardInfo.tel;
      let params = {
        phone: phone,
        shopCode: _this.shopInfo.shopCode,
      };
      let url = "/api/mbrinfo/getStoredValueCard";
      queryGet(url, params)
        .then((resp) => {
          let _data = resp.data;
          if (_data.code == "0000") {
            let _result = _data.data;
            _this.cardLists = _result.results.valueCardQueryVo.valueCardVosl;
            for (let i = 0; i < _this.cardLists.length; i++) {
              if (_this.cardLists[i].prepaidCardCode == _this.cardNo) {
                _this.cardIndex = i;
                sessionStorage.setItem(
                  "cardInfo",
                  JSON.stringify(this.cardLists[i])
                );
                break;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },
    getCardInfoByNo(cardNo) {
      getCardInfo(cardNo)
        .then((resp) => {
          let _data = resp.data;
          if (_data.code == "0000") {
            this.cardLists = _data.results.valueCardVosl;
          } else {
            this.$toast.fail(_data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toCardRecharge() {
      this.$router.push("cardRecharge");
    },
    toShopcart() {
      this.$router.push("buy");
    },
    toCardRecord() {
      this.$router.push("cardRecord");
    },
    changeCard(index) {
      sessionStorage.setItem("cardInfo", JSON.stringify(this.cardLists[index]));
      this.cardIndex = index;
    },
  },
};
</script>


